import Icon from "@/components/library/Icon";
import type { IForgotPasswordAlertViewModel } from "../Types/LoginTypes";

const ForgotPasswordAlert = ({ vm }: { vm: IForgotPasswordAlertViewModel }) => (
  <div
    className="flex flex-col items-center gap-4 py-4 text-center"
    id="forgot-password-alert"
    data-testid="forgot-password-alert"
    data-active={vm.dataActive}
  >
    <span className="text-dines-green">
      <Icon icon={vm.icon} size="3x" />
    </span>
    <p className="max-w-xs font-bold text-white text-xl leading-tight sm:text-2xl">
      {vm.labels.alertTitle}
    </p>
  </div>
);

export default ForgotPasswordAlert;
